import { useWebWoodContext } from 'context/WebWoodContext'
import { ProcessingEvent } from '@renderforest/webwood-engine'
import { useEffect, useState } from 'react'

export const useFontLoading = (timelineItemId: string | undefined) => {
  const { engine } = useWebWoodContext()
  const [isFontLoading, setIsFontLoading] = useState(false)

  useEffect(() => {
    if (!engine || !timelineItemId) {
      setIsFontLoading(false)
      return
    }

    const handler = ({ id, isLoading }: { id: string; isLoading: boolean }) => {
      if (id !== timelineItemId) return
      setIsFontLoading(isLoading)
    }

    engine.signals.on(ProcessingEvent.OBJECT_FONT_LOADING, handler)
    return () => {
      engine.signals.off(ProcessingEvent.OBJECT_FONT_LOADING, handler)
    }
  }, [engine, timelineItemId])

  return isFontLoading
}
